import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import TwoMapPinsConnectedWithCurvyDottedLine from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoMapPinsConnectedWithCurvyDottedLine';
import TwoPeopleTwoWayArrows from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPeopleTwoWayArrows';
// styles
import { ColStyled } from './styles';

export default () => (
  <SectionContainer
    id='universal-life-insurance-product-callout-grouping'
    backgroundVariant='lightC'
    themeType='lightTheme'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col large={8}>
        <Typography
          align='center'
          component='h2'
          nextElement='graphic'>
          What types of universal life insurance policies does Northwestern <WidowBlock>Mutual offer&#63;</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='left'>
      <ColStyled
        medium={6}
        large={4}>
        <ProductCard
          icon={TwoMapPinsConnectedWithCurvyDottedLine}
          backgroundVariant='lightA'
          cardId='product-callout-custom-universal-life-link-card'
          cardHeading='Custom Universal Life'
          cardText='Have more flexibility when it comes to choosing the amount of your death benefit and your premium payment schedule. This type of policy insures one person and builds cash value, tax deferred.'
        />
      </ColStyled>
      <ColStyled
        medium={6}
        large={4}>
        <ProductCard
          icon={TwoPeopleTwoWayArrows}
          backgroundVariant='lightA'
          cardId='product-callout-survivorship-universal-life-link-card'
          cardHeading='Survivorship Universal Life'
          cardText='Similar to Custom Universal Life, except Survivorship Universal Life lets you insure two people and pays the death benefit upon the death of the second person.'
        />
      </ColStyled>
      <ColStyled
        medium={6}
        large={4}
        disableBottomPadding>
        <ProductCard
          icon={TwoPeopleTwoWayArrows}
          backgroundVariant='lightA'
          cardId='product-callout-survivorship-variable-universal-life-link-card'
          cardHeading='Variable Universal Life'
          cardText={<>Just like Universal Life, you&#39;ll get lifelong protection,<sup>3</sup> cash value accumulation,<sup>2</sup> and an adjustable premium,<sup>4</sup> plus you can choose how to invest<sup>5</sup> the cash value to help produce greater returns.</>}
          linkId='product-callout-variable-universal-life-link'
          linkText='Find out more'
          linkUrl='/life-insurance/variable-universal-life-insurance-vul/'
          ariaLabel='Find out more about variable universal life insurance.'
        />
      </ColStyled>
    </Row>
  </SectionContainer>
);

